<template>
    <v-form ref="exportOrdersForm">
        <export-orders-fields :initialValue="formData" @update="syncFormData" @validityChanged="syncFormValidity" :validateOnLoad="validateOnLoad"></export-orders-fields>

        <!--Only show cancel if text is set. Always show submit, but only enable it if the form is valid-->
        <v-btn v-if="cancelButtonText" @click="raiseCancel" flat color="error">{{cancelButtonText}}</v-btn>
        <v-btn @click="submit" :disabled="!formValid">{{submitButtonText}}</v-btn>
    </v-form>
</template>

<script>
  import {FormMixin, BasicFormSyncMixin} from '@/forms/mixins'
  import ExportOrdersFields from '@/forms/dataops/ExportOrdersFields'

  export default {
    name: 'ExportOrdersForm',
    mixins: [FormMixin, BasicFormSyncMixin],
    components: {ExportOrdersFields}
  }
</script>

<style scoped>

</style>
